const gr = {
    buttons: {
        login: "ΣΥΝΔΕΣΗ",
        register: "ΕΓΓΡΑΦΗ",
        search: "Αναζήτηση",
        add_blacklist: "Προσθήκη στη μαύρη λίστα",
        accept_all: "Αποδοχή όλων",
        export_naf: "Λήψη Αρχείου NAF",
        export_dapf: "Λήψη Αρχείου DAPF",
        previous: "Προηγούμενη",
        next: "Επόμενη",
    },
    dropdown: {
        set_admin_role: "Ρόλος Διαχειριστή",
        set_user_role: "Ρόλος Χρήστη",
        set_status_accepted: "Αποδοχή",
        set_status_rejected: "Απορριψη",
        set_status_pending: "Εκκρεμής",
        set_status_paid: "Πληρώθηκε",
        set_deleted: "Διαγραφή"
    },
    account: {
        postal_address_details: "Στοιχεία Ταχυδρομικής Διεύθυνσης",
        district: "Επαρχία",
        municipality: "Δήμος / Κοινότητα",
        quarter: "Ενορία",
        address: "Οδός",
        address2: "Κτίριο / Διαμέρισμα",
        house_no: "Αριθμός Οικίας",
        postal_code: "Ταχυδρομικός Κώδικας",
        select_district: "Επιλέξτε Επαρχία",
        select_municipality: "Επιλέξτε Δήμο/Κοινότητα",
        select_quarter: "Επιλέξτε Ενορία",
        select_street: "Επιλέξτε Οδό",
        select_postal_code: "Επιλέξτε Ταχυδρομικό Κώδικα",
    },
    titles: {
        app_name: "ΑΚΑΜΑΣ",
        total_payments: "Σύνολο Πληρωμών",
        total_apps: "Σύνολο Αιτήσεων",
        no_parcel_found:"Δεν βρέθηκαν αποτελέσματα",
        new: "Νέα καταχώρηση",
        export: "Εξαγωγή",
        company_id: "Αριθμός Μητρώου Εταιρίας",
        dashboard: "Πίνακας Ελέγχου",
        applications: "Οι Αιτήσεις μου",
        account: "Ο Λογαριασμός μου",
        admin: "Διαχείριση",
        admin_upper: "ΔΙΑΧΕΙΡΙΣΗ",
        enquiries: "Αιτήσεις",
        users: "Χρήστες",
        statistics: "Στατιστικά",
        app_map: "Χάρτης Αιτήσεων",
        area_map: 'Χάρτης Περιοχής',
        admin_map: 'Χάρτης Διαχείρισης',
        settings: "Ρυθμίσεις",
        logout: "Αποσύνδεση",
        menu: "Μενού",
        contact: "Επικοινωνία",
        home: "Αρχική Σελίδα",
        disclaimer: "Αποποίηση ευθυνών",
        address: "Διεύθυνση",
        telephone: "Τηλέφωνο",
        copyright: "Κυπριακή Δημοκρατία - Υπουργείο Γεωργίας, Αγροτικής Ανάπτυξης και Περιβάλλοντος",
        powered_by: "Αναπτύχθηκε από Geo-Grafica Ltd",
        name: "Όνομα / Επώνυμο",
        national_id: "Αρ. Ταυτότητας",
        email: "Ηλ. Ταχυδρομ.",
        phone_number: "Αρ. Τηλεφώνου",
        iban_number: "Αρ. IBAN",
        type: "Τύπος Προφίλ",
        role: "Ρόλος",
        reg_date: "Ημ. Δημιουργ.",
        user_profile: "Προφίλ Χρήστη",
        user_profile_update: "Ανανέωση Προφίλ",
        user_profile_update_success:"Το προφίλ ενημερώθηκε με επιτυχία",
        select_year: "Επιλέξτε Έτος",
        all: "Ολα",
        total_users: "Σύνολο Χρηστών",
        apps_by_village: "Αιτήσεις ανά χωριό",
        ownerships_by_village: "Ιδιοκτησίες ανά χωριό",
        total_paid_by_village: "Σύνολο πληρωμών ανά χωριό",
        village_code: "Χωριό",
        total: "Σύνολο",
        application_id: "Αρ. Αίτησης",
        id: "Α/Α",
        unique_identifier: "Διακρ. Αριθμός",
        actions: "Ενέργειες",
        iban_error: "Mη έγκυρος αριθμός IBAN",
        download_csv: "Λήψη Αρχείου CSV",
        payments: "Πληρωμές",
        no_payments: "Δεν υπάρχουν πληρωμές",
        blacklist: "Μαύρη λίστα",
        help: "Οδηγίες Χρήσης",
        phone_error: "Mη έγκυρος αριθμός Τηλεφώνου. Παρακαλώ καταχωρήστε ένα έγκυρο Αριθμό Τηλεφώνου",
    },
    home: {
        title: "ΤΟΠΙΚΟ ΣΧΕΔΙΟ ΑΚΑΜΑ - ΕΠΙΔΟΤΗΣΗ ΑΚΙΝΗΤΗΣ ΙΔΙΟΚΤΗΣΙΑΣ",
        title_2: "Υλοποίηση Πλαισίου Μέτρων και Δράσεων Ενίσχυσης της Αναπτυξιακής Δραστηριότητας των Κοινοτήτων Ακάμα.",
        description: "Παραχώρηση επιδότησης στους ιδιοκτήτες γης με βάση την έκταση, λόγω της συμβολής των τεμαχίων της υπαίθρου στην προστασία του τοπίου της περιοχής, καθώς και στη διατήρηση της βιοποικιλότητας της.",
        description_2: "Σκοπός του μέτρου είναι η οικονομική ενίσχυση και στήριξη των ιδιοκτητών γης (Νομικά ή φυσικά πρόσωπα) εντός των ορίων του Τοπικού Σχεδίου Ακάμα, λόγω της συμβολής των τεμαχίων γης στην προστασία του τοπίου, καθώς και στη διατήρηση της βιοποικιλότητας της περιοχής, η οποία είναι μοναδική σε εθνικό επίπεδο.",
        description_3: "Το μέτρο θα υλοποιηθεί μέσω εθνικών πόρων, θα ισχύει για μία πενταετία και θα επανεξεταστεί μετά το πέρας της πενταετίας, βάσει της απόδοσης ωφελειών από τα άλλα μέτρα κοινωνικοοικονομικής ενίσχυσης της περιοχής.",
        description_4: "Υλοποίηση Μέτρου Αρ. 1",
        description_5: "Απαιτείται Εγγραφή στην υπηρεσία CY Login",
        description_6: "Η ενίσχυση προτείνεται να παραχωρείται σε φυσικά και νομικά πρόσωπα, τα οποία κατόπιν υποβολής αίτησης στον Φορέα εφαρμογής του μέτρου και τεκμηρίωσης της ιδιοκτησιακής τους ιδιότητας, θα λαμβάνουν ετησίως ποσό ανάλογο με την αξία ενοικίων γεωργικής γης στην περιοχή και της περιβαλλοντικής συνεισφοράς της ιδιοκτησίας.",
        description_7: "Οι υποχρεώσεις των ιδιοκτητών βάσει του σχεδίου, θα είναι να διατηρήσουν την ιδιοκτησία τους στην υφιστάμενή της κατάσταση. Συνεπώς, εάν η ιδιοκτησία παρουσιάζει γεωργική δραστηριότητα αυτή να συνεχίσει, ενώ εάν παραμένει σε αδράνεια να μην υπάρξει διατάραξη του τοπίου και της φυσικής βλάστησης που έχει αναπτυχθεί, αλλά διαχείριση της βλάστησης αυτής, έτσι ώστε να προάγεται η προστασία των οικοτόπων, ειδών και οικοσυστημικών υπηρεσιών. Πρόσθετα θα υποχρεούται να μην την περιφράξει και να μην παρεμβεί σε αυτή με οποιοδήποτε τρόπο. Παρόλα αυτά, θα δίνεται η ευελιξία αλλαγής δραστηριότητας εντός του τεμαχίου γης (π.χ. από εγκαταλελειμμένη γεωργική γη σε αξιοποιήσιμη), βάσει έγκρισης σχετικής αίτησης από Επιτροπή Αξιολόγησης Αιτήσεων.",
        description_8: "Καθορίζεται ως οροφή ενίσχυσης ανά δικαιούχο €6.600 ετησίως.",
        description_9: "Το Υπουργείο Γεωργίας, Αγροτικής Ανάπτυξης και Περιβάλλοντος ανακοινώνει την εφαρμογή του Μέτρου 1 για την περιοχή του Ακάμα για το 2026",
        description_10: "Η διαδικασία υποβολής αιτήσεων θα πραγματοποιηθεί μέσω της ηλεκτρονικής πλατφόρμας",
        description_10_after: "από 1η Οκτωβρίου 2026 μέχρι την 15η Νοεμβρίου 2026 και αφορά τόσο φυσικά όσο και νομικά πρόσωπα (εταιρείες) που επιθυμούν να συμμετάσχουν στο Σχέδιο",
        platform_url: "https://support-akamas.com",
        platform_text: "https://support-akamas.com",
        description_11: "Μετά την εν λόγω περίοδο δεν θα είναι εφικτή η υποβολή αιτήσεων.",
        description_12: "Για περισσότερες πληροφορίες σχετικά με την υποβολή αιτήσεων, οι ενδιαφερόμενοι μπορούν να απευθύνονται στην Ομάδα Υποστήριξης, στο τηλέφωνο 22408952 ή μέσω ηλεκτρονικού ταχυδρομείου στη διεύθυνση",
        description_email: "support-akamas@moa.gov.cy",
        instructions: "Για οδηγίες χρήσης της πλατφόρμας παρακαλώ πατήστε",
    },
    dashboard: {
        account: "Για ενημέρωση Προφίλ πατήστε",
        application: "Για υποβολή Αίτησης πατήστε",
        here: "εδώ"
    },
    applications: {
        try_again: "Υπάρχουν τεχνικά προβλήματα, δοκιμάστε ξανά αργότερα",
        owner: "Ιδιοκτήτης",
        no_apps: "Δεν υπάρχουν αιτήσεις",
        no_ownerships: "Δεν βρέθηκαν ιδιοκτησίες",
        loading: "Φόρτωση αιτήσεων...",
        new_application: "ΝΕΑ ΑΙΤΗΣΗ",
        id: "Α/Α",
        external_id: "Αρ. Αίτησης",
        year: "Έτος",
        status: "Κατάσταση",
        application_date: "Ημ. Υποβολής",
        total_area: "Συνολ. Εκταση",
        subsidy: "Επιδότηση",
        general_info: "Γενικές Πληροφορίες",
        owner_info: "ΠΛΗΡΟΦΟΡΙΕΣ ΙΔΙΟΚΤΗΤΗ",
        application_info: "ΠΛΗΡΟΦΟΡΙΕΣ ΑΙΤΗΣΗΣ",
        app_id: "Αρ. Αίτησης",
        ownerships: "Ιδιοκτησίες",
        location: "Τοποθεσία",
        subprop_id: "Υπό-Ιδιοκτησία",
        district: "Επ.",
        community: "Δήμ/Κοιν",
        quarter: "Εν.",
        sheet: "Φλ.",
        plan: "Σχέδιο",
        block: "Τμ.",
        parcel_no: "Αρ. Τεμ.",
        scale: "Κλίμακα",
        registration: "Αρ. Εγ.",
        locality: "Τοποθεσία",
        extent: "Έκτ.",
        share: "Μερ.",
        per_page: "Ανά Σελίδα",
        total_extent: "Συνολική Έκταση",
        total_subsidy: "Συνολική Επιδότηση",
        property_disclaimer: "Αν οποιοδήποτε από τα ακίνητά σας δεν εμφανίζεται στη λίστα, παρακαλώ απευθυνθείτε σε ένα Επαρχιακό Κτηματολογικό Γραφείο ή χρησιμοποιήστε την ή-αίτηση για να δηλώσετε το ακίνητό σας.",
        property_disclaimer2: "Το θέμα θα ερευνηθεί από αρμόδιο Λειτουργό και θα ενημερωθείτε σχετικά.",
        property_disclaimer_url: "https://eforms.eservices.cyprus.gov.cy/MOI/LS/DeclarationSubmit?_lang=el",
        property_disclaimer_url_text: "Δήλωση Ακινήτου (Μέσω Συστήματος GOV.CY)", 
        agree_terms: "Συμφωνώ να μην προβώ σε αλλαγή της χρήσης γης, στην τοποθέτηση περίφραξης ή σε οποιαδήποτε άλλη επέμβαση στις ιδιοκτησίες που περιλαμβάνονται στην παρούσα αίτηση, για περίοδο ενός (1) έτους.",
    },
    dialogs: {
        confirm_title: "Υποβολή",
        confirm_body: "Είστε βέβαιος ότι θέλετε να υποβάλετε την αίτησή σας;",
        confirm_no: "Όχι",
        confirm_yes: "Ναι",
        confirm_submit: "Υποβολή Αίτησης",
        profile_title: "Υποβολή",
        profile_body: "Είστε βέβαιος ότι θέλετε να ενημερώσετε το προφίλ σας;",
        profile_no: "Όχι",
        profile_yea: "Ναι",
        profile_submit: "Ενημέρωση Προφίλ",
        inform_title: "Πληροφορία",
        inform_ok: "Εντάξει",
        inform_error: "Παρουσιάστηκε σφάλμα στην εφαρμογή",
        inform_invalid_iban: "Παρακαλώ ενημερώστε τον Λογαριασμό σας με έγκυρο Αριθμό IBAN",
        inform_invalid_phone: "Παρακαλώ ενημερώστε τον Λογαριασμό σας με έγκυρο Αριθμό Τηλεφώνου",
        inform_invalid_address: "Παρακαλώ ενημερώστε τον Λογαριασμό σας με έγκυρη Ταχυδρομική Διεύθυνση",
        please_wait: "Παρακαλώ Περιμένετε...",
        gathering_ownerships: "Ανάκτηση Ιδιοκτησιών..."
    },
    urls: {
        home_url: "https://www.gov.cy/moa/",
        contact_url: "https://www.gov.cy/moa/contact/",
        disclaimer_url: "https://www.gov.cy/moa/politiki-aporritoy/",
        user_manual_url: "https://support-akamas.com/Akamas_User_Manual_gr.pdf",
    },
    settings: {
        ownerships_title: "Ημερομηνία Ιδιοκτησιών",
        ownerships_date: "Παρακαλώ επιλέξτε Ημερομηνία Ιδιοκτησιών",
        ownerships_save: "Φύλαξη",
        activation_title: "Ενεργοποίηση Συστήματος",
        activate_button: "Ενεργοποίηση",
        activate_desc: "Το Σύστημα είναι Ενεργό και δέχεται Αιτήσεις",
        deactivate_desc: "Το Σύστημα είναι Ανενεργό",
        deactivate_button: "Απενεργοποίηση",
    }
  };
  
export default gr
